import React, { useEffect, useState } from "react";
import CareersLayout from "./layouts/CareersLayout";
import useFilters from "helpers/hooks/useFilters";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import useListingHeader from "helpers/hooks/useListingHeader";
import useCareers from "store/careers/service-hook";
import CareersListing from "./listing/CareersSkillsListing";
import usePagination from "helpers/hooks/usePagination";
import { payloadBool } from "helpers/utils/utilities";

const Skills = () => {
  const { search, setGridType, setSearch, gridType, setSort, sort } =
    useListingHeader(1, "relevance");
  const { selected } = useFilters();
  const { t } = useLocalizedTranslation();
  const { fetchSkills } = useCareers();
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const { page, pages, setPagination, setPage, totalCount } = usePagination();

  useEffect(() => {
    handleFetchSkills();
  }, [sort, search, selected?.career_status, page]);

  const handleFetchSkills = async () => {
    setLoading(true);
    const filters = { sort_by: sort, page, search };
    if (selected.career_status)
      filters["saved"] = payloadBool(selected?.career_status === "saved");
    const res = await fetchSkills(filters);
    setSkills(res?.list || []);
    setPagination(res);
    setLoading(false);
  };

  return (
    <CareersLayout
      search={search}
      setSearch={setSearch}
      gridType={gridType}
      setGridType={setGridType}
      setSort={setSort}
      sort={sort}
      isSkills
      loading={loading}
    >
      {!loading && skills?.length ? (
        <h4 className="mt-4 ml-2">{totalCount} Results</h4>
      ) : null}
      <CareersListing
        t={t}
        list={skills}
        setList={setSkills}
        gridType={gridType}
        loading={loading}
        page={page}
        pageCount={pages}
        setPage={setPage}
        isSkills
      />
    </CareersLayout>
  );
};

export default Skills;
